export default "__VITE_ASSET__VS3zbxzI__"